<sb-evo-slide-player
  *ngIf="presentation"
  [embedded]="true"
  [liveEnabled]="false"
  [keyboardEnabled]="true"
  [nonNativeFullScreenEnabled]="false"
  [presentation]="presentation"
></sb-evo-slide-player>

<div
  *ngIf="!presentation"
  class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-muted"
>
  <sb-spinner *ngIf="isBusy" class="h1" [visible]="isBusy"></sb-spinner>

  <ng-container *ngIf="!isBusy">
    <span class="h1">
      <i class="fal fa-eye-slash"></i>
    </span>
    <p>
      {{
        "Huh... seems like this presentation no longer exists or it's private."
          | translate
      }}
    </p>
  </ng-container>
</div>
